export default {
    "name": "Permissions",
    "kind": "HoudiniFragment",
    "hash": "3f76d0b4017e1a73cf166b01088aab2f1caa56ec1edfd5f74b2839e97f150439",

    "raw": `fragment Permissions on Session {
  permissions {
    CONFIGURATION_CAN_CONFIGURE_STORES
    CUSTOMERS_CAN_ADD
    CUSTOMERS_CAN_EDIT_ADDRESSES
    CUSTOMERS_CAN_EDIT_ADVANCED
    CUSTOMERS_CAN_EDIT_BILLING_ADDRESS
    CUSTOMERS_CAN_EDIT_CREDIT_LIMIT
    CUSTOMERS_CAN_EDIT_CUSTOMERS
    CUSTOMERS_CAN_EDIT_PRICING
    CUSTOMERS_CAN_EDIT_SALESMAN_STORE
    CUSTOMERS_CAN_EDIT_TERMS
    CUSTOMERS_CAN_MANAGE_MESSAGES
    CUSTOMERS_CAN_MANAGE_OPTIONS
    CUSTOMERS_CAN_MANAGE_UNITS
    CUSTOMERS_CAN_MERGE
    DASHBOARD_CHART_EDIT
    DASHBOARD_CHART_EDIT_QUERY
    DASHBOARD_REPORT_EDIT_ALL
    DASHBOARD_REPORT_EDIT_OWN
    DASHBOARD_REPORT_VIEW
    GLOBAL_USER_ADMINISTRATOR
    INTERCHANGE_CAN_OPEN_SCREEN
    PART_CONFIGURATION_CAN_EDIT_PART_TYPES
    PARTS_CAN_CLONE_PARTS
    PARTS_CAN_CREATE_CONDITIONS
    PARTS_CAN_EDIT_ATTACHMENTS
    PARTS_CAN_EDIT_COST
    PARTS_CAN_EDIT_GLCATEGORY
    PARTS_CAN_EDIT_INFO
    PARTS_CAN_EDIT_LOCATION
    PARTS_CAN_EDIT_PRICES
    PARTS_CAN_EDIT_QUANTITY
    PARTS_CAN_EDIT_STATUS
    PARTS_CAN_EDIT_STOCKING_DATA
    PARTS_CAN_REPLICATE_PARTS
    PARTS_CAN_SAVE_PARTS
    PARTS_CAN_VIEW_COST
    PARTS_CAN_VIEW_PARTS
    PARTS_EDIT_RESTRICTED_PART_TYPE_PRICES
    PARTS_EDIT_RESTRICTED_PURCHASE_VENDOR
    PURCHASE_ORDERS_CAN_VIEW
    SALES_ORDERS_CAN_VIEW
    SEARCH_CAN_SEARCH_VEHICLES
    SETTINGS_GROUP_ADMINISTRATOR
    TRANSFER_ORDERS_CAN_VIEW
    VEHICLES_CAN_CHANGE_STOCK_QUANTITY
    VEHICLES_CAN_EDIT_ADDITIONAL_INFORMATION
    VEHICLES_CAN_EDIT_ATTACHMENTS
    VEHICLES_CAN_EDIT_BASIC
    VEHICLES_CAN_EDIT_BIDS
    VEHICLES_CAN_EDIT_GL_CATEGORY
    VEHICLES_CAN_EDIT_NON_BID_UNITS
    VEHICLES_CAN_EDIT_QANDA
    VEHICLES_CAN_EDIT_STATUS
    VEHICLES_CAN_EDIT_STOCK_NUMBER
    VEHICLES_CAN_EDIT_WHOLE_UNIT_ADVANCED
    VEHICLES_CAN_EDIT_WHOLE_UNITS
    VEHICLES_CAN_VIEW_VEHICLE_PERFORMANCE
    VENDORS_CAN_EDIT_VENDORS
    VENDORS_CAN_MERGE
    WEB_CAN_LOGIN
    WORK_ORDERS_CAN_VIEW
  }
  id
  __typename
}
`,

    "rootType": "Session",
    "stripVariables": [],

    "selection": {
        "fields": {
            "permissions": {
                "type": "SessionPermissions",
                "keyRaw": "permissions",

                "selection": {
                    "fields": {
                        "CONFIGURATION_CAN_CONFIGURE_STORES": {
                            "type": "Boolean",
                            "keyRaw": "CONFIGURATION_CAN_CONFIGURE_STORES",
                            "visible": true
                        },

                        "CUSTOMERS_CAN_ADD": {
                            "type": "Boolean",
                            "keyRaw": "CUSTOMERS_CAN_ADD",
                            "visible": true
                        },

                        "CUSTOMERS_CAN_EDIT_ADDRESSES": {
                            "type": "Boolean",
                            "keyRaw": "CUSTOMERS_CAN_EDIT_ADDRESSES",
                            "visible": true
                        },

                        "CUSTOMERS_CAN_EDIT_ADVANCED": {
                            "type": "Boolean",
                            "keyRaw": "CUSTOMERS_CAN_EDIT_ADVANCED",
                            "visible": true
                        },

                        "CUSTOMERS_CAN_EDIT_BILLING_ADDRESS": {
                            "type": "Boolean",
                            "keyRaw": "CUSTOMERS_CAN_EDIT_BILLING_ADDRESS",
                            "visible": true
                        },

                        "CUSTOMERS_CAN_EDIT_CREDIT_LIMIT": {
                            "type": "Boolean",
                            "keyRaw": "CUSTOMERS_CAN_EDIT_CREDIT_LIMIT",
                            "visible": true
                        },

                        "CUSTOMERS_CAN_EDIT_CUSTOMERS": {
                            "type": "Boolean",
                            "keyRaw": "CUSTOMERS_CAN_EDIT_CUSTOMERS",
                            "visible": true
                        },

                        "CUSTOMERS_CAN_EDIT_PRICING": {
                            "type": "Boolean",
                            "keyRaw": "CUSTOMERS_CAN_EDIT_PRICING",
                            "visible": true
                        },

                        "CUSTOMERS_CAN_EDIT_SALESMAN_STORE": {
                            "type": "Boolean",
                            "keyRaw": "CUSTOMERS_CAN_EDIT_SALESMAN_STORE",
                            "visible": true
                        },

                        "CUSTOMERS_CAN_EDIT_TERMS": {
                            "type": "Boolean",
                            "keyRaw": "CUSTOMERS_CAN_EDIT_TERMS",
                            "visible": true
                        },

                        "CUSTOMERS_CAN_MANAGE_MESSAGES": {
                            "type": "Boolean",
                            "keyRaw": "CUSTOMERS_CAN_MANAGE_MESSAGES",
                            "visible": true
                        },

                        "CUSTOMERS_CAN_MANAGE_OPTIONS": {
                            "type": "Boolean",
                            "keyRaw": "CUSTOMERS_CAN_MANAGE_OPTIONS",
                            "visible": true
                        },

                        "CUSTOMERS_CAN_MANAGE_UNITS": {
                            "type": "Boolean",
                            "keyRaw": "CUSTOMERS_CAN_MANAGE_UNITS",
                            "visible": true
                        },

                        "CUSTOMERS_CAN_MERGE": {
                            "type": "Boolean",
                            "keyRaw": "CUSTOMERS_CAN_MERGE",
                            "visible": true
                        },

                        "DASHBOARD_CHART_EDIT": {
                            "type": "Boolean",
                            "keyRaw": "DASHBOARD_CHART_EDIT",
                            "visible": true
                        },

                        "DASHBOARD_CHART_EDIT_QUERY": {
                            "type": "Boolean",
                            "keyRaw": "DASHBOARD_CHART_EDIT_QUERY",
                            "visible": true
                        },

                        "DASHBOARD_REPORT_EDIT_ALL": {
                            "type": "Boolean",
                            "keyRaw": "DASHBOARD_REPORT_EDIT_ALL",
                            "visible": true
                        },

                        "DASHBOARD_REPORT_EDIT_OWN": {
                            "type": "Boolean",
                            "keyRaw": "DASHBOARD_REPORT_EDIT_OWN",
                            "visible": true
                        },

                        "DASHBOARD_REPORT_VIEW": {
                            "type": "Boolean",
                            "keyRaw": "DASHBOARD_REPORT_VIEW",
                            "visible": true
                        },

                        "GLOBAL_USER_ADMINISTRATOR": {
                            "type": "Boolean",
                            "keyRaw": "GLOBAL_USER_ADMINISTRATOR",
                            "visible": true
                        },

                        "INTERCHANGE_CAN_OPEN_SCREEN": {
                            "type": "Boolean",
                            "keyRaw": "INTERCHANGE_CAN_OPEN_SCREEN",
                            "visible": true
                        },

                        "PART_CONFIGURATION_CAN_EDIT_PART_TYPES": {
                            "type": "Boolean",
                            "keyRaw": "PART_CONFIGURATION_CAN_EDIT_PART_TYPES",
                            "visible": true
                        },

                        "PARTS_CAN_CLONE_PARTS": {
                            "type": "Boolean",
                            "keyRaw": "PARTS_CAN_CLONE_PARTS",
                            "visible": true
                        },

                        "PARTS_CAN_CREATE_CONDITIONS": {
                            "type": "Boolean",
                            "keyRaw": "PARTS_CAN_CREATE_CONDITIONS",
                            "visible": true
                        },

                        "PARTS_CAN_EDIT_ATTACHMENTS": {
                            "type": "Boolean",
                            "keyRaw": "PARTS_CAN_EDIT_ATTACHMENTS",
                            "visible": true
                        },

                        "PARTS_CAN_EDIT_COST": {
                            "type": "Boolean",
                            "keyRaw": "PARTS_CAN_EDIT_COST",
                            "visible": true
                        },

                        "PARTS_CAN_EDIT_GLCATEGORY": {
                            "type": "Boolean",
                            "keyRaw": "PARTS_CAN_EDIT_GLCATEGORY",
                            "visible": true
                        },

                        "PARTS_CAN_EDIT_INFO": {
                            "type": "Boolean",
                            "keyRaw": "PARTS_CAN_EDIT_INFO",
                            "visible": true
                        },

                        "PARTS_CAN_EDIT_LOCATION": {
                            "type": "Boolean",
                            "keyRaw": "PARTS_CAN_EDIT_LOCATION",
                            "visible": true
                        },

                        "PARTS_CAN_EDIT_PRICES": {
                            "type": "Boolean",
                            "keyRaw": "PARTS_CAN_EDIT_PRICES",
                            "visible": true
                        },

                        "PARTS_CAN_EDIT_QUANTITY": {
                            "type": "Boolean",
                            "keyRaw": "PARTS_CAN_EDIT_QUANTITY",
                            "visible": true
                        },

                        "PARTS_CAN_EDIT_STATUS": {
                            "type": "Boolean",
                            "keyRaw": "PARTS_CAN_EDIT_STATUS",
                            "visible": true
                        },

                        "PARTS_CAN_EDIT_STOCKING_DATA": {
                            "type": "Boolean",
                            "keyRaw": "PARTS_CAN_EDIT_STOCKING_DATA",
                            "visible": true
                        },

                        "PARTS_CAN_REPLICATE_PARTS": {
                            "type": "Boolean",
                            "keyRaw": "PARTS_CAN_REPLICATE_PARTS",
                            "visible": true
                        },

                        "PARTS_CAN_SAVE_PARTS": {
                            "type": "Boolean",
                            "keyRaw": "PARTS_CAN_SAVE_PARTS",
                            "visible": true
                        },

                        "PARTS_CAN_VIEW_COST": {
                            "type": "Boolean",
                            "keyRaw": "PARTS_CAN_VIEW_COST",
                            "visible": true
                        },

                        "PARTS_CAN_VIEW_PARTS": {
                            "type": "Boolean",
                            "keyRaw": "PARTS_CAN_VIEW_PARTS",
                            "visible": true
                        },

                        "PARTS_EDIT_RESTRICTED_PART_TYPE_PRICES": {
                            "type": "Boolean",
                            "keyRaw": "PARTS_EDIT_RESTRICTED_PART_TYPE_PRICES",
                            "visible": true
                        },

                        "PARTS_EDIT_RESTRICTED_PURCHASE_VENDOR": {
                            "type": "Boolean",
                            "keyRaw": "PARTS_EDIT_RESTRICTED_PURCHASE_VENDOR",
                            "visible": true
                        },

                        "PURCHASE_ORDERS_CAN_VIEW": {
                            "type": "Boolean",
                            "keyRaw": "PURCHASE_ORDERS_CAN_VIEW",
                            "visible": true
                        },

                        "SALES_ORDERS_CAN_VIEW": {
                            "type": "Boolean",
                            "keyRaw": "SALES_ORDERS_CAN_VIEW",
                            "visible": true
                        },

                        "SEARCH_CAN_SEARCH_VEHICLES": {
                            "type": "Boolean",
                            "keyRaw": "SEARCH_CAN_SEARCH_VEHICLES",
                            "visible": true
                        },

                        "SETTINGS_GROUP_ADMINISTRATOR": {
                            "type": "Boolean",
                            "keyRaw": "SETTINGS_GROUP_ADMINISTRATOR",
                            "visible": true
                        },

                        "TRANSFER_ORDERS_CAN_VIEW": {
                            "type": "Boolean",
                            "keyRaw": "TRANSFER_ORDERS_CAN_VIEW",
                            "visible": true
                        },

                        "VEHICLES_CAN_CHANGE_STOCK_QUANTITY": {
                            "type": "Boolean",
                            "keyRaw": "VEHICLES_CAN_CHANGE_STOCK_QUANTITY",
                            "visible": true
                        },

                        "VEHICLES_CAN_EDIT_ADDITIONAL_INFORMATION": {
                            "type": "Boolean",
                            "keyRaw": "VEHICLES_CAN_EDIT_ADDITIONAL_INFORMATION",
                            "visible": true
                        },

                        "VEHICLES_CAN_EDIT_ATTACHMENTS": {
                            "type": "Boolean",
                            "keyRaw": "VEHICLES_CAN_EDIT_ATTACHMENTS",
                            "visible": true
                        },

                        "VEHICLES_CAN_EDIT_BASIC": {
                            "type": "Boolean",
                            "keyRaw": "VEHICLES_CAN_EDIT_BASIC",
                            "visible": true
                        },

                        "VEHICLES_CAN_EDIT_BIDS": {
                            "type": "Boolean",
                            "keyRaw": "VEHICLES_CAN_EDIT_BIDS",
                            "visible": true
                        },

                        "VEHICLES_CAN_EDIT_GL_CATEGORY": {
                            "type": "Boolean",
                            "keyRaw": "VEHICLES_CAN_EDIT_GL_CATEGORY",
                            "visible": true
                        },

                        "VEHICLES_CAN_EDIT_NON_BID_UNITS": {
                            "type": "Boolean",
                            "keyRaw": "VEHICLES_CAN_EDIT_NON_BID_UNITS",
                            "visible": true
                        },

                        "VEHICLES_CAN_EDIT_QANDA": {
                            "type": "Boolean",
                            "keyRaw": "VEHICLES_CAN_EDIT_QANDA",
                            "visible": true
                        },

                        "VEHICLES_CAN_EDIT_STATUS": {
                            "type": "Boolean",
                            "keyRaw": "VEHICLES_CAN_EDIT_STATUS",
                            "visible": true
                        },

                        "VEHICLES_CAN_EDIT_STOCK_NUMBER": {
                            "type": "Boolean",
                            "keyRaw": "VEHICLES_CAN_EDIT_STOCK_NUMBER",
                            "visible": true
                        },

                        "VEHICLES_CAN_EDIT_WHOLE_UNIT_ADVANCED": {
                            "type": "Boolean",
                            "keyRaw": "VEHICLES_CAN_EDIT_WHOLE_UNIT_ADVANCED",
                            "visible": true
                        },

                        "VEHICLES_CAN_EDIT_WHOLE_UNITS": {
                            "type": "Boolean",
                            "keyRaw": "VEHICLES_CAN_EDIT_WHOLE_UNITS",
                            "visible": true
                        },

                        "VEHICLES_CAN_VIEW_VEHICLE_PERFORMANCE": {
                            "type": "Boolean",
                            "keyRaw": "VEHICLES_CAN_VIEW_VEHICLE_PERFORMANCE",
                            "visible": true
                        },

                        "VENDORS_CAN_EDIT_VENDORS": {
                            "type": "Boolean",
                            "keyRaw": "VENDORS_CAN_EDIT_VENDORS",
                            "visible": true
                        },

                        "VENDORS_CAN_MERGE": {
                            "type": "Boolean",
                            "keyRaw": "VENDORS_CAN_MERGE",
                            "visible": true
                        },

                        "WEB_CAN_LOGIN": {
                            "type": "Boolean",
                            "keyRaw": "WEB_CAN_LOGIN",
                            "visible": true
                        },

                        "WORK_ORDERS_CAN_VIEW": {
                            "type": "Boolean",
                            "keyRaw": "WORK_ORDERS_CAN_VIEW",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "id": {
                "type": "UInt",
                "keyRaw": "id",
                "visible": true
            },

            "__typename": {
                "type": "String",
                "keyRaw": "__typename",
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    }
};

"HoudiniHash=4e7c02de33f1fde1a2384e8e52a5de731dddfe527602ebae324292cfdddb7535";